module.exports = __webpack_public_path__ + "img/weih.4afa47f3.png";